import api from '@/api';

const SET_STUDENT = 'SET_STUDENT';

export default {
  namespaced: true,

  state: () => ({
    student: null,
  }),

  getters: {
    getStudent: ({ student }) => student,
  },

  actions: {
    /**
     * @param commit
     * @param {string} studentId
     * @returns {Promise<Object>}
     */
    async fetchStudent({ commit }, studentId) {
      const student = await api.getStudent(studentId);
      commit(SET_STUDENT, student);
      return student;
    },
  },

  mutations: {
    [SET_STUDENT](state, payload) {
      state.student = payload;
    },
  },
};
